import { getSetting, setSetting } from 'local/lib/settings';
import delegateEvent from '@bleckert/delegate-event';
import { machine } from 'local/test/machine';
import agent from 'local/test/agent';
import el from 'local/lib/el';
import { onOpen } from '@internetstiftelsen/styleguide/dist/molecules/modal/modal';
import testIpType from 'local/test/testIpType';

function setMeasurementServer(url) {
	machine.setData({
		server: machine.data.getServerByUrl(url),
	});
}

function setMeasurementAlgorithm(algorithm) {
	agent.send({
		method: 'setConfigurationOption',
		args: {
			'Measure.Algorithm': algorithm,
		},
	});
}

class AdvancedSettings {
	constructor() {
		this.el = el('advancedSettings');

		if (!this.el) {
			return;
		}

		this.ipv4 = el('ipTypeIpv4');
		this.ipv6 = el('ipTypeIpv6');
		this.start = el('advancedMeasurementStart');
		this.measurementServer = el('measurementServer');
		this.measurementAlgorithm = el('measurementAlgorithm');

		this.sync();
		this.attach();
	}

	setIptype(value, sync = true) {
		const iptype = value === 'ipv6' ? 'ipv6' : 'ipv4';

		this.ipv4.checked = iptype === 'ipv4';
		this.ipv6.checked = iptype === 'ipv6';

		if (sync) {
			setSetting('iptype', iptype);
		}

		machine.setData({ iptype });
	}

	sync() {
		this.setIptype(getSetting('iptype'), false);
	}

	fillServerList(iptype) {
		const { configuration } = machine.data;

		if (!configuration) {
			return;
		}

		this.measurementServer.innerHTML = '';

		configuration.servers.forEach((server) => {
			if (server.type === iptype && server.tlsport === 443) {
				this.measurementServer.innerHTML += `<option value="${server.url}">${server.name}</option>`;
			}
		});

		this.measurementServer.disabled = false;
	}

	attach() {
		delegateEvent(
			'change',
			'[name="ip"]',
			(e, target) => this.setIptype(target.value),
			this.el,
		);

		this.start.addEventListener('click', (e) => {
			e.preventDefault();

			document.getElementById('closeAdvancedMeasurementModal').click();
			document.getElementById('measure').click();
		});

		this.measurementServer.addEventListener('change', (e) =>
			setMeasurementServer(e.target.value),
		);

		this.measurementAlgorithm.addEventListener('change', (e) =>
			setMeasurementAlgorithm(e.target.value),
		);

		machine.on('data', (data) => {
			if ('configuration' in data || 'iptype' in data) {
				this.fillServerList(data.iptype || machine.data.iptype);
			}

			this.ipv4.disabled = machine.data.ipv4Supported === false;
			this.ipv6.disabled = machine.data.ipv6Supported === false;

			if (this.ipv6.checked && machine.data.ipv6Supported === false) {
				this.setIptype('ipv4');
			}

			if (this.ipv4.checked && machine.data.ipv4Supported === false && machine.data.ipv6Supported) {
				this.setIptype('ipv6');
			}
		});

		machine.on('transition', (state) => {
			this.start.disabled = state === 'MEASURING';
		});
	}
}

onOpen((el) => {
	if (el.id === 'advancedMeasurementModal') {
		testIpType(machine);
	}
});

export default new AdvancedSettings();
